import React, { useEffect, useRef, useState } from "react";
import { Button, Input, LoginWrapper, SVG } from "shared";
import "./LoginPage.scss";
import { Field, Formik, Form } from "formik";
import { ROUTE_ENUM, SVG_ENUM, VALIDATION_ENUM } from "enums";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import { useGetMe, useLogin } from "hooks/auth";
import { checkIfLogged } from "utils";

type LoginPageProps = {};

const LoginPage: React.FC<LoginPageProps> = () => {
  const navigate = useNavigate();
  const formRef = useRef<any>(null);
  const [showError, setShowError] = useState(false);
  const { data: authorizedUser } = useGetMe();
  const { mutate } = useLogin({
    onSuccess: () => {
      if (sessionStorage.getItem("destinationPath")) {
        navigate(sessionStorage.getItem("destinationPath") as string);
        sessionStorage.removeItem("destinationPath");
      } else {
        navigate(ROUTE_ENUM.DASHBOARD);
      }
    },
    onError: (error: Error) => {
      setShowError(true);
    },
  });

  const validation = () =>
    Yup.object().shape({
      password: Yup.string()
        .required(VALIDATION_ENUM.REQUIRED)
        .min(8, VALIDATION_ENUM.MIN_8),
    });

  const initialValues = {
    password: "",
  };

  const onSubmit = (values: typeof initialValues) => {
    mutate(values);
  };

  useEffect(() => {
    if (authorizedUser) {
      checkIfLogged(authorizedUser, navigate);
    }
  }, [authorizedUser, navigate]);

  return (
    <LoginWrapper>
      <div className="login-admin">
        <div className="login-admin__logo">
          <SVG type={SVG_ENUM.LOGO} />
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={(values) => onSubmit(values)}
          validationSchema={validation()}
          innerRef={formRef}
        >
          {({ errors, values, handleSubmit, setFieldValue }) => (
            <Form>
              <p
                className={`login-admin__error ${
                  showError ? "login-admin__error--show" : ""
                }`}
              >
                Niepoprawne dane logowania
                <SVG type={SVG_ENUM.CLOSE_CIRCLE} />
              </p>
              <Field
                type="password"
                id="password"
                onFocus={() => setShowError(false)}
                name="password"
                label={"Hasło"}
                as={Input}
              />

              <Button
                label="Zaloguj się"
                className="button--black login-wrapper__submit button--wide"
                styleType="primary"
                onClick={() => {
                  handleSubmit();
                }}
              />
            </Form>
          )}
        </Formik>
      </div>
    </LoginWrapper>
  );
};

export default LoginPage;
